module.exports = {
	"data": {
		"site": {
			"siteMetadata": {
				"title": "KeystoneJS"
			}
		},
		"allMarkdownRemark": {
			"edges": [
				{
					"node": {
						"section": "Configuration",
						"slug": "/configuration",
						"headings": [
							{
								"value": "Keystone Setup Options"
							}
						]
					}
				},
				{
					"node": {
						"section": "Database",
						"slug": "/database",
						"headings": [
							{
								"value": "Database Options"
							}
						]
					}
				},
				{
					"node": {
						"section": "Database",
						"slug": "/database/relationships",
						"headings": [
							{
								"value": "Relationships"
							}
						]
					}
				},
				{
					"node": {
						"section": "Field",
						"slug": "/field",
						"headings": [
							{
								"value": "Field types"
							}
						]
					}
				},
				{
					"node": {
						"section": "Field",
						"slug": "/field/options",
						"headings": [
							{
								"value": "Field Options"
							}
						]
					}
				},
				{
					"node": {
						"section": "List",
						"slug": "/list/add",
						"headings": [
							{
								"value": "Add"
							}
						]
					}
				},
				{
					"node": {
						"section": "List",
						"slug": "/list",
						"headings": [
							{
								"value": "List"
							}
						]
					}
				},
				{
					"node": {
						"section": "List",
						"slug": "/list/model",
						"headings": [
							{
								"value": "Model"
							}
						]
					}
				},
				{
					"node": {
						"section": "List",
						"slug": "/list/options",
						"headings": [
							{
								"value": "List Construction Options"
							}
						]
					}
				},
				{
					"node": {
						"section": "List",
						"slug": "/list/register",
						"headings": [
							{
								"value": "Register"
							}
						]
					}
				},
				{
					"node": {
						"section": "List",
						"slug": "/list/schema",
						"headings": [
							{
								"value": "Schema"
							}
						]
					}
				},
				{
					"node": {
						"section": "List",
						"slug": "/list/update-item",
						"headings": [
							{
								"value": "Update Item"
							}
						]
					}
				},
				{
					"node": {
						"section": "Methods",
						"slug": "/methods/close-database-connection",
						"headings": [
							{
								"value": "Close Database connection"
							}
						]
					}
				},
				{
					"node": {
						"section": "Methods",
						"slug": "/methods/create-items",
						"headings": [
							{
								"value": "Create Items"
							}
						]
					}
				},
				{
					"node": {
						"section": "Methods",
						"slug": "/methods/create-router",
						"headings": [
							{
								"value": "Create Router"
							}
						]
					}
				},
				{
					"node": {
						"section": "Methods",
						"slug": "/methods/get",
						"headings": [
							{
								"value": "Get"
							}
						]
					}
				},
				{
					"node": {
						"section": "Methods",
						"slug": "/methods/import",
						"headings": [
							{
								"value": "Import"
							}
						]
					}
				},
				{
					"node": {
						"section": "Methods",
						"slug": "/methods/importer",
						"headings": [
							{
								"value": "Importer"
							}
						]
					}
				},
				{
					"node": {
						"section": "Methods",
						"slug": "/methods",
						"headings": [
							{
								"value": "Methods"
							}
						]
					}
				},
				{
					"node": {
						"section": "Methods",
						"slug": "/methods/init",
						"headings": [
							{
								"value": "Init"
							}
						]
					}
				},
				{
					"node": {
						"section": "Methods",
						"slug": "/methods/list",
						"headings": [
							{
								"value": "list"
							}
						]
					}
				},
				{
					"node": {
						"section": "Methods",
						"slug": "/methods/middleware",
						"headings": [
							{
								"value": "Middleware"
							}
						]
					}
				},
				{
					"node": {
						"section": "Methods",
						"slug": "/methods/open-database-connection",
						"headings": [
							{
								"value": "Open Database Connection"
							}
						]
					}
				},
				{
					"node": {
						"section": "Methods",
						"slug": "/methods/paginate",
						"headings": [
							{
								"value": "Paginate"
							}
						]
					}
				},
				{
					"node": {
						"section": "Methods",
						"slug": "/methods/pre",
						"headings": [
							{
								"value": "Pre"
							}
						]
					}
				},
				{
					"node": {
						"section": "Methods",
						"slug": "/methods/set",
						"headings": [
							{
								"value": "Set"
							}
						]
					}
				},
				{
					"node": {
						"section": "Methods",
						"slug": "/methods/start",
						"headings": [
							{
								"value": "Start"
							}
						]
					}
				},
				{
					"node": {
						"section": "Methods",
						"slug": "/methods/update-handler",
						"headings": [
							{
								"value": "Update Handler"
							}
						]
					}
				},
				{
					"node": {
						"section": "View",
						"slug": "/view",
						"headings": [
							{
								"value": "View"
							}
						]
					}
				},
				{
					"node": {
						"section": "View",
						"slug": "/view/on",
						"headings": [
							{
								"value": "on"
							}
						]
					}
				},
				{
					"node": {
						"section": "View",
						"slug": "/view/query",
						"headings": [
							{
								"value": "query"
							}
						]
					}
				},
				{
					"node": {
						"section": "View",
						"slug": "/view/render",
						"headings": [
							{
								"value": "render"
							}
						]
					}
				},
				{
					"node": {
						"section": "Guides",
						"slug": "/guides/api-file-image-uploads",
						"headings": [
							{
								"value": "API File and Image Uploads"
							}
						]
					}
				},
				{
					"node": {
						"section": "Guides",
						"slug": "/guides/how-to-create-a-blog-with-keystone",
						"headings": [
							{
								"value": "How to create a blog with Keystone"
							}
						]
					}
				},
				{
					"node": {
						"section": "Guides",
						"slug": "/guides/how-to-send-emails",
						"headings": [
							{
								"value": "How to send emails with Keystone"
							}
						]
					}
				},
				{
					"node": {
						"section": "Guides",
						"slug": "/guides",
						"headings": [
							{
								"value": "Guides"
							}
						]
					}
				},
				{
					"node": {
						"section": "Guides",
						"slug": "/guides/v-0-3-to-v-4-0-upgrade-guide",
						"headings": [
							{
								"value": "Upgrade Guide: 0.3 to 4.0"
							}
						]
					}
				},
				{
					"node": {
						"section": "Guides",
						"slug": "/guides/yo-generator",
						"headings": [
							{
								"value": "Keystone Yeoman Generator"
							},
							{
								"value": "Routes & Views"
							}
						]
					}
				},
				{
					"node": {
						"section": "Introduction",
						"slug": "/introduction/getting-started",
						"headings": [
							{
								"value": "Getting Started"
							}
						]
					}
				},
				{
					"node": {
						"section": "Introduction Setting Up",
						"slug": "/introduction/setting-up/part-2",
						"headings": [
							{
								"value": "Part 2 - Database Setup"
							}
						]
					}
				},
				{
					"node": {
						"section": "Introduction Setting Up",
						"slug": "/introduction/setting-up/part-1",
						"headings": [
							{
								"value": "Part 1: Initial Setup"
							}
						]
					}
				},
				{
					"node": {
						"section": "Introduction Setting Up",
						"slug": "/introduction/setting-up/part-3",
						"headings": [
							{
								"value": "Part 3: Routing"
							}
						]
					}
				},
				{
					"node": {
						"section": "Introduction Setting Up",
						"slug": "/introduction/setting-up/part-4",
						"headings": [
							{
								"value": "Part 4 -  Adding data to the database from a form"
							}
						]
					}
				},
				{
					"node": {
						"section": "Field",
						"slug": "/field/azurefile",
						"headings": [
							{
								"value": "AzureFile Field"
							}
						]
					}
				},
				{
					"node": {
						"section": "Field",
						"slug": "/field/embedly",
						"headings": [
							{
								"value": "Embedly Field"
							}
						]
					}
				},
				{
					"node": {
						"section": "Field",
						"slug": "/field/file",
						"headings": [
							{
								"value": "File Field"
							}
						]
					}
				},
				{
					"node": {
						"section": "Field",
						"slug": "/field/localfile",
						"headings": [
							{
								"value": "LocalFile Field"
							}
						]
					}
				},
				{
					"node": {
						"section": "Field",
						"slug": "/field/localfiles",
						"headings": [
							{
								"value": "Local Files"
							}
						]
					}
				},
				{
					"node": {
						"section": "Field",
						"slug": "/field/s-3-file",
						"headings": [
							{
								"value": "S3 File Field"
							}
						]
					}
				},
				{
					"node": {
						"section": "Field",
						"slug": "/field/boolean",
						"headings": [
							{
								"value": "Boolean Field"
							}
						]
					}
				},
				{
					"node": {
						"section": "Field",
						"slug": "/field/cloudinaryimages",
						"headings": [
							{
								"value": "CloudinaryImages Field"
							}
						]
					}
				},
				{
					"node": {
						"section": "Field",
						"slug": "/field/cloudinaryimage",
						"headings": [
							{
								"value": "CloudinaryImage Field"
							}
						]
					}
				},
				{
					"node": {
						"section": "Field",
						"slug": "/field/code",
						"headings": [
							{
								"value": "Code Field"
							}
						]
					}
				},
				{
					"node": {
						"section": "Field",
						"slug": "/field/color",
						"headings": [
							{
								"value": "Color Field"
							}
						]
					}
				},
				{
					"node": {
						"section": "Field",
						"slug": "/field/date",
						"headings": [
							{
								"value": "Date Field"
							}
						]
					}
				},
				{
					"node": {
						"section": "Field",
						"slug": "/field/datearray",
						"headings": [
							{
								"value": "Datearray field"
							}
						]
					}
				},
				{
					"node": {
						"section": "Field",
						"slug": "/field/datetime",
						"headings": [
							{
								"value": "DateTime Field"
							}
						]
					}
				},
				{
					"node": {
						"section": "Field",
						"slug": "/field/email",
						"headings": [
							{
								"value": "Email Field"
							}
						]
					}
				},
				{
					"node": {
						"section": "Field",
						"slug": "/field/geopoint",
						"headings": [
							{
								"value": "GeoPoint Field"
							}
						]
					}
				},
				{
					"node": {
						"section": "Field",
						"slug": "/field/html",
						"headings": [
							{
								"value": "HTML Field"
							}
						]
					}
				},
				{
					"node": {
						"section": "Field",
						"slug": "/field/key",
						"headings": [
							{
								"value": "Key Field"
							}
						]
					}
				},
				{
					"node": {
						"section": "Field",
						"slug": "/field/location",
						"headings": [
							{
								"value": "Location Field"
							}
						]
					}
				},
				{
					"node": {
						"section": "Field",
						"slug": "/field/markdown",
						"headings": [
							{
								"value": "Markdown Field"
							}
						]
					}
				},
				{
					"node": {
						"section": "Field",
						"slug": "/field/money",
						"headings": [
							{
								"value": "Money Field"
							}
						]
					}
				},
				{
					"node": {
						"section": "Field",
						"slug": "/field/name",
						"headings": [
							{
								"value": "Name Field"
							}
						]
					}
				},
				{
					"node": {
						"section": "Field",
						"slug": "/field/number",
						"headings": [
							{
								"value": "Number Field"
							}
						]
					}
				},
				{
					"node": {
						"section": "Field",
						"slug": "/field/numberarray",
						"headings": [
							{
								"value": "NumberArray field"
							}
						]
					}
				},
				{
					"node": {
						"section": "Field",
						"slug": "/field/password",
						"headings": [
							{
								"value": "Password Field"
							}
						]
					}
				},
				{
					"node": {
						"section": "Field",
						"slug": "/field/relationship",
						"headings": [
							{
								"value": "Relationship Field"
							}
						]
					}
				},
				{
					"node": {
						"section": "Field",
						"slug": "/field/select",
						"headings": [
							{
								"value": "Select Field"
							}
						]
					}
				},
				{
					"node": {
						"section": "Field",
						"slug": "/field/text",
						"headings": [
							{
								"value": "Text Field"
							}
						]
					}
				},
				{
					"node": {
						"section": "Field",
						"slug": "/field/textarea",
						"headings": [
							{
								"value": "Textarea Field"
							}
						]
					}
				},
				{
					"node": {
						"section": "Field",
						"slug": "/field/textarray",
						"headings": [
							{
								"value": "Textarray Field"
							}
						]
					}
				},
				{
					"node": {
						"section": "Field",
						"slug": "/field/url",
						"headings": [
							{
								"value": "URL Field"
							}
						]
					}
				}
			]
		},
		"markdownRemark": {
			"parent": {
				"relativePath": "List/options.md"
			},
			"slug": "/list/options",
			"headings": [
				{
					"value": "List Construction Options"
				}
			],
			"html": "<h1 id=\"list-construction-options\"><a href=\"#list-construction-options\" aria-hidden=\"true\" class=\"anchor\"><svg aria-hidden=\"true\" height=\"16\" version=\"1.1\" viewBox=\"0 0 16 16\" width=\"16\"><path fill-rule=\"evenodd\" d=\"M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z\"></path></svg></a>List Construction Options</h1>\n<p>The following is a list of all options for the keystone List <a href=\"/list\">constructor</a>, and their effects on the created list. Note that many of these can also be set by the constructor when the list is created.</p>\n<h4 data-primitive-type=\"String\"><code>label</code></h4>\n<p>The label used for the list in the Admin UI. Defaults to a friendly form of <code>key</code></p>\n<h4 data-primitive-type=\"String\"><code>path</code></h4>\n<p>The path used for the list in the Admin UI. Defaults to a slugified form of <code>key</code>.</p>\n<h4 data-primitive-type=\"String\"><code>singular</code></h4>\n<p>The singular label for the items in the list. Used in the Admin UI, defaults to a singular form of <code>label</code>.</p>\n<h4 data-primitive-type=\"String\"><code>plural</code></h4>\n<p>The plural label for the items in the list. Used in the Admin UI, defaults to a plural form of <code>singular</code></p>\n<h4 data-primitive-type=\"String\"><code>schema</code></h4>\n<p>Options for the Mongoose Schema for the List. Among other things, this option lets you specify a custom name for the collection. See the <a href=\"http://mongoosejs.com/docs/guide.html#options\">mongoose schema docs</a> for a list of available options.\n<em>Warning: do not modify the <code>id</code> or <code>_id</code> schema options; the default behaviour is required by Keystone</em></p>\n<blockquote>\n<p>NOTE If you’re wondering how to control which navigation area Lists are categorised under in the Admin UI, check out the nav option in the KeystoneJS Configuration docs.</p>\n</blockquote>\n<h4 data-primitive-type=\"Boolean\"><code>noedit</code></h4>\n<p>Disable the item from being edited in the admin UI or by <a href=\"/list/update-item\">updateItem</a> when true by mapping <code>noedit</code> to all fields on the list.</p>\n<h4 data-primitive-type=\"Boolean\"><code>nocreate</code></h4>\n<p>Disable creation of new items in the admin UI. Items may still be created by the keystone server.</p>\n<h4 data-primitive-type=\"Boolean\"><code>nodelete</code></h4>\n<p>Disable deleting items in the admin UI. Items may still be deleted by the keystone server.</p>\n<h4 data-primitive-type=\"Boolean\"><code>hidden</code></h4>\n<p>If true, the list is hidden from the keystone admin UI.</p>\n<h4 data-primitive-type=\"Mixed\"><code>track</code></h4>\n<p>Sets up 4 fields that will be attached to the list; <code>createdAt</code>, <code>createdBy</code>, <code>updatedAt</code>, and <code>updatedBy</code>. <code>track</code> accepts a boolean value or an object. For a boolean <code>true</code>, all four fields are added. If an object is passed, any keys with value true for the fields will cause that field to be created.</p>\n<ul>\n<li>createdAt adds a pre-save hook, and is set to <code>new Date()</code> if the item is new.</li>\n<li>updatedAt adds a pre-save hook, and is set to <code>new Date()</code> if the item is new or modified.</li>\n<li>createdBy is a relationship field to your <a href=\"/configuration/#user-model\">user model</a>, which will be automatically set by the admin UI if the item is new.</li>\n<li>udpatedBy is a relationship field to your <a href=\"/configuration/#user-model\">user model</a>, which will be automatically set by the admin UI if the item is new or modified.</li>\n</ul>\n<p>If you want to update <code>createdBy</code> and <code>updatedBy</code> on server side saves, you can use <a href=\"/list/update-item\">updateItem</a> to pass in a user.</p>\n<p>Example:</p>\n<pre><code class=\"language-javascript\">Event<span class=\"token punctuation\">.</span>track <span class=\"token operator\">=</span> <span class=\"token punctuation\">{</span>\n\tcreatedAt<span class=\"token punctuation\">:</span> <span class=\"token boolean\">true</span><span class=\"token punctuation\">,</span>\n\tcreatedBy<span class=\"token punctuation\">:</span> <span class=\"token boolean\">true</span><span class=\"token punctuation\">,</span>\n<span class=\"token punctuation\">}</span></code></pre>\n<h4 data-primitive-type=\"String\"><code>drilldown</code></h4>\n<p>A space-delimited list of relationships to display as drilldown in the Admin UI</p>\n<h4 data-primitive-type=\"String\"><code>sortContext</code></h4>\n<p>A <code>List:relationship</code> pair to control when drag and drop sorting is available in the Admin UI</p>\n<h4 data-primitive-type=\"Number\"><code>perPage</code></h4>\n<p>Sets the number of items to be loaded per page on the keystone admin UI.</p>\n<h4 data-primitive-type=\"String\"><code>searchFields</code></h4>\n<p>A space-delimited list of paths to use for searching in Admin UI.</p>\n<h4 data-primitive-type=\"Object\"><code>map</code></h4>\n<p>An object that maps fields to special <strong>list</strong> paths. Each path defaults to its key if a field with that key is added. Mappable paths include</p>\n<ul>\n<li>name - the field that contains the name of the item, for display in the Admin UI.</li>\n</ul>\n<h4 data-primitive-type=\"Object\"><code>autokey</code></h4>\n<p>Adds a plugin to the list that automatically generates a key for each document when it is saved, based on the value of another field or path. The value of the option should be an object with the following keys:</p>\n<ul>\n<li><code>from</code> String - the field or path to generate the key from, can be a space-delimited list of fields</li>\n<li><code>path</code> String - the path to store the key at</li>\n<li>unique Boolean - whether the key should be unique or not</li>\n<li><code>fixed</code> Boolean - the key should be kept if it exists and it’s non-empty.</li>\n</ul>\n<p>Defaults to <code>false</code>.</p>\n<p><em>Autokey paths are automatically indexed; you may also want to include them in compound indexes.</em></p>\n<h4 data-primitive-type=\"Mixed\"><code>defaultColumns</code></h4>\n<p>Defines the default columns to be displayed in the keystone admin UI list view. If nothing is provided, default columns will be set to just the name field.</p>\n<p>Set up default columns before registering the list.</p>\n<p>Example:</p>\n<pre><code class=\"language-javascript\">Event<span class=\"token punctuation\">.</span>defaultColumns <span class=\"token operator\">=</span> <span class=\"token string\">'name, displayName, email'</span><span class=\"token punctuation\">;</span></code></pre>\n<p><code>defaultColumns</code> can be provided as a string of comma-separated values or as an array.</p>\n<h4 data-primitive-type=\"Boolean\"><code>sortable</code></h4>\n<p>Provides a sort order for the list, and the ability to re-sort items in the admin UI by dragging and dropping them. This should not be used alongside <code>defaultSort</code>, as defaultSort will override the ability to see the sortOrder.</p>\n<p>This adds a hidden field to the schema which is <code>sortOrder</code>, which is a number. Keystone updates the <code>sortOrder</code> whenever an item is dragged in the admin UI, changing all necessary items to correct the sortOrder.</p>\n<h4 data-primitive-type=\"String\"><code>defaultSort</code></h4>\n<p>List option for what field to sort by in the admin UI. Defaults to the name field. Accepts a string.</p>\n<p>You can reverse the sort order by adding a <code>-</code> symbol before the field name.</p>\n<p>Example:</p>\n<pre><code class=\"language-javascript\">Event<span class=\"token punctuation\">.</span>defaultSort <span class=\"token operator\">=</span> <span class=\"token string\">'-createdAt'</span></code></pre>\n<p>This will sort by the <code>createdAt</code> field, with the earliest created items first.</p>\n<h4 data-primitive-type=\"List Schema\"><code>inherits</code></h4>\n<p>You can make a list that inherits from another registered keystone list. This can add new fields to a schema, as well as adding a <code>__t</code> property to the schema with the value of the sublist name. In mongo, only one collection is created.</p>\n<p>An example of inheritance would be:</p>\n<pre><code class=\"language-javascript\"><span class=\"token keyword\">var</span> Post <span class=\"token operator\">=</span> <span class=\"token keyword\">new</span> <span class=\"token class-name\">keystone<span class=\"token punctuation\">.</span>List</span><span class=\"token punctuation\">(</span><span class=\"token string\">'Post'</span><span class=\"token punctuation\">)</span><span class=\"token punctuation\">;</span>\nPost<span class=\"token punctuation\">.</span><span class=\"token function\">add</span><span class=\"token punctuation\">(</span><span class=\"token punctuation\">{</span>\n\tname<span class=\"token punctuation\">:</span> <span class=\"token punctuation\">{</span> type<span class=\"token punctuation\">:</span> String<span class=\"token punctuation\">,</span> required<span class=\"token punctuation\">:</span> <span class=\"token boolean\">true</span> <span class=\"token punctuation\">}</span><span class=\"token punctuation\">,</span>\n\tpublishDate<span class=\"token punctuation\">:</span> <span class=\"token punctuation\">{</span> type<span class=\"token punctuation\">:</span> Types<span class=\"token punctuation\">.</span>DateTime <span class=\"token punctuation\">}</span><span class=\"token punctuation\">,</span>\n<span class=\"token punctuation\">}</span><span class=\"token punctuation\">)</span><span class=\"token punctuation\">;</span>\nPost<span class=\"token punctuation\">.</span><span class=\"token function\">register</span><span class=\"token punctuation\">(</span><span class=\"token punctuation\">)</span><span class=\"token punctuation\">;</span>\n<span class=\"token keyword\">var</span> ReferencedArticle <span class=\"token operator\">=</span> <span class=\"token keyword\">new</span> <span class=\"token class-name\">keystone<span class=\"token punctuation\">.</span>List</span><span class=\"token punctuation\">(</span><span class=\"token string\">'ReferencedArticle'</span><span class=\"token punctuation\">,</span> <span class=\"token punctuation\">{</span> inherits<span class=\"token punctuation\">:</span> Post <span class=\"token punctuation\">}</span><span class=\"token punctuation\">)</span><span class=\"token punctuation\">;</span>\nReferencedArticle<span class=\"token punctuation\">.</span><span class=\"token function\">add</span><span class=\"token punctuation\">(</span><span class=\"token punctuation\">{</span> referenceList<span class=\"token punctuation\">:</span> Types<span class=\"token punctuation\">.</span>Textarray <span class=\"token punctuation\">}</span><span class=\"token punctuation\">)</span><span class=\"token punctuation\">;</span>\nReferencedArticle<span class=\"token punctuation\">.</span><span class=\"token function\">register</span><span class=\"token punctuation\">(</span><span class=\"token punctuation\">)</span></code></pre>\n<p>You can now make queries just against the <code>Article</code> collections, which will filter only articles, or against all Posts, which are stored in a single collection.</p>\n<p>In the keystone admin UI, both the list and the sub-list will be visible.</p>\n<p>Inheritance can only occur one level deep, so a list that inherits cannot also be inherited from.</p>"
		}
	},
	"pathContext": {
		"slug": "/list/options"
	}
};


//////////////////
// WEBPACK FOOTER
// ./.intermediate-representation/json/list-options.json
// module id = ./.intermediate-representation/json/list-options.json
// module chunks = 38